
import Vue from 'vue'
import RequesterForm from '@/components/RequesterForm.vue'
import ProjectForm from '@/components/ProjectForm.vue'
import QuoteTable from '@/components/QuoteTable.vue'

export default Vue.extend({
  components: {
    RequesterForm,
    ProjectForm,
    QuoteTable
  },

  data: () => ({
    stepperStep: 1
  }),

  computed: {
    steps () {
      return [
        {
          title: 'Ajánlatkérői adatok',
          subtitle: this.$store.state.requester.name,
          component: RequesterForm,
          usableCondition: (): boolean => true,
          editableCondition: (): boolean => true
        },
        {
          title: 'Projektadatok',
          subtitle: this.$store.state.projectData.projectTitle,
          component: ProjectForm,
          usableCondition: (): boolean => (this as any).step1valid(), //eslint-disable-line
          editableCondition: (): boolean => (this as any).step1valid() //eslint-disable-line
        },
        {
          title: 'Anyagjegyzék',
          component: QuoteTable,
          usableCondition: (): boolean => (this as any).step2valid(), //eslint-disable-line
          editableCondition: (): boolean => false
        }
      ]
    }
  },

  methods: {
    step1valid (): boolean {
      return this.$store.state.formValidity.requesterForm
    },
    step2valid (): boolean {
      return (this as any).step1valid() && this.$store.state.formValidity.projectForm && this.$store.state.formValidity.roomsForm //eslint-disable-line
    },
    moveToNextStepIfPossible () {
      if (this.steps[this.stepperStep].usableCondition()) {
        this.stepperStep++
      }
    },
    reset () {
      this.stepperStep = 1
    }
  }
})
